import {gql} from '@apollo/client';

export default gql`
  mutation deleteCompanyClaim($input: DeleteCompanyClaimInput!) {
    authed {
      success
    }
    deleteCompanyClaim(input: $input) {
      success
    }
  }
`;
